import React from "react";
import card1 from "../../assets/img/cards-4.png";
import card2 from "../../assets/img/cards-2.png";
import card3 from "../../assets/img/cards-6.jpg";
import { useTranslation } from "react-i18next";

const FeaturesSection = () => {
  const { t } = useTranslation();

  return (
    <section id="featured" className="featured section">
      <div className="container section-title" data-aos="fade-up">
        <h2>{t("features.title")}</h2>
        <p>{t("features.subtitle")}</p>
      </div>

      <div className="container">
        <div className="row gy-4" data-aos="fade-up" data-aos-delay="100">
          <div className="col-md-4">
            <div className="card">
              <div className="img">
                <img src={card1} alt="" className="img-fluid" />
                <div className="icon">
                  <i className="bi bi-people"></i>
                </div>
              </div>
              <h2 className="title">{t("features.cards.team.title")}</h2>
              <p>{t("features.cards.team.desc")}</p>
            </div>
          </div>

          <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
            <div className="card">
              <div className="img">
                <img src={card2} alt="" className="img-fluid" />
                <div className="icon">
                  <i className="bi bi-calendar-check"></i>
                </div>
              </div>
              <h2 className="title">{t("features.cards.calendar.title")}</h2>
              <p>{t("features.cards.calendar.desc")}</p>
            </div>
          </div>

          <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
            <div className="card">
              <div className="img">
                <img src={card3} alt="" className="img-fluid" />
                <div className="icon">
                  <i className="bi bi-window-stack"></i>
                </div>
              </div>
              <h2 className="title">{t("features.cards.profile.title")}</h2>
              <p>{t("features.cards.profile.desc")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
